export default __webpack_public_path__ + "static/media/vpn.237f1106.png";